document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.variant-name.form__label').forEach(function(el) {
        if (el.textContent.trim().startsWith('Color')) {
            el.innerHTML = el.innerHTML.replace('Color', 'Colour');
        }
    });

    document.querySelectorAll('.variants-selector.color').forEach(function(el) {
        let titleAttr = el.getAttribute('title');
        if (titleAttr && titleAttr.includes('Color')) {
            el.setAttribute('title', titleAttr.replace('Color', 'Colour'));
        }
    });
});
